import * as Yup from 'yup';
import { TFunction } from 'i18next';

export default function validationSchema(t: TFunction) {
  return Yup.object({
    title: Yup.string().required().label(t('event.label.title')),
    from: Yup.date().required().label(t('event.label.from')),
    to: Yup.date().required().label(t('event.label.to')),
    categoryId: Yup.string().label(t('event.label.category')),
    isPrivate: Yup.boolean().required().label(t('event.label.isPrivate')),
  });
}
